import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class ProveedorService {

  constructor(private config: ConfigService, private http: HttpClient) { }

  getPoliticasComerciales = (token: String) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Proveedor/PoliticaComercial";
    return this.http.get(url, requestOptions);
  }


  getVendedoresActivos = (token: String, idPerfil: number) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Proveedor/GetEmpleados/" + idPerfil;
    return this.http.get(url, requestOptions);
  }

  setUsersTienda = (token: String, data: Array<any>, idPerfil: number) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      responseType: 'Text'
    });
    const url = this.config.urlService + "api/Proveedor/SetAsignarUsuarios/" + idPerfil;
    return this.http.post(url, data, requestOptions);
  }

  setUsers = (token: String, data: Array<any>) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      responseType: 'Text'
    });
    const url = this.config.urlService + "api/Proveedor/crearUsuario";
    return this.http.post(url, data, requestOptions);
  }

  getVentasDiscriminacionPagoProveedor(token: String, date: string, idProveedor: number) {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
    });
    const url = this.config.urlService + "api/Proveedor/Pagos/" + date + "/" + idProveedor;
    return this.http.get(url, requestOptions);
  }

  getTiendas = (token: string, idProveedor: number,) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
    });
    const url = this.config.urlService + "api/Proveedor/GetTiendas/" + idProveedor;
    return this.http.get(url, requestOptions);
  }

  /**
   * 
   * @param token 
   * @param idProveedor 
   * @param idProducto 
   * @param isVendible: parametro usado para saber si es para venta o no la localidad
   * @returns 
   */
  getInventarioTiendas = (token: string, idProveedor: number, idProducto: number, isVendible?: boolean) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
    });
    const url = this.config.urlService + "api/Proveedor/GetTiendas/Inventario/" + idProveedor + "/" + idProducto + "/" + (!isVendible ? true : isVendible);
    return this.http.get(url, requestOptions);
  }
}
